var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.889,7H48.833V1H42.722V7H18.278V1H12.167V7H9.111a6.028,6.028,0,0,0-6.081,6L3,55a6.055,6.055,0,0,0,6.111,6H51.889A6.074,6.074,0,0,0,58,55V13A6.074,6.074,0,0,0,51.889,7Zm0,48H9.111V22H51.889ZM15.222,28H30.5V43H15.222Z",
    transform: "translate(-3 -1)",
    fill: "#ababab"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.0b1234d8.svg";
export { ForwardRef as ReactComponent };